export enum NAVIGATION {
    LOGIN = "/login",
    USERS = "/users",
    CONTENT = "/content",
    FAQ = "/content/faq",
    TERMS = "/content/terms",
    ABOUT = "/content/about",
    CONTACT = "/content/contact"
}
